var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Problems',{staticClass:"home",attrs:{"questions":_vm.questions}})
}
var staticRenderFns = []

export { render, staticRenderFns }